<div class="grid forgot-password-container full-height-grid">
  <div class="col-12 md:col-5 fixed-sidebar p-0">
    <app-login-info />
  </div>
  <div class="col-12 md:col-7 scrollable-content pt-6">
    <div class="grid">
      <div class="hidden md:block md:col-1"></div>

      <div class="col-12 md:col-10">
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
          <div class="grid">
            <div class="flex col-12 reset-password-title gap-2 mb-4">
              {{ 'Auth.ForgotPassword' | translate }}
            </div>
            <div
              class="col-12 mb-4 justify-content-center align-items-center forgot-instructions"
              innerHTML="{{ 'Auth.ForgotPasswordInstruction' | translate }}"></div>
            <div class="col-12 mb-4">
              <div class="flex flex-column">
                <label class="input-title" htmlFor="password">{{ 'Auth.Email' | translate }}</label>
                <input pInputText id="email" aria-describedby="email-help" formControlName="email" class="w-full" />
              </div>
              @if (
                forgotPasswordForm.controls.email.touched && forgotPasswordForm.controls.email.hasError('required')
              ) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.EmailAddressRequired' | translate }}" />
              }

              @if (forgotPasswordForm.controls.email.touched && forgotPasswordForm.controls.email.hasError('pattern')) {
                <p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
                  icon="pi pi-info-circle"
                  text="{{ 'SignUp.InvalidEmail' | translate }}" />
              }
            </div>
            <div class="col-12 mb-4">
              @for (msg of messages; track msg) {
                <p-message class="w-full" [closable]="true" [severity]="$any(msg.severity)" [icon]="msg.icon">
                  <div class="content-box">
                    <span class="summary-txt">{{ msg.severity }}</span>
                    <span>{{ msg.detail }}</span>
                  </div>
                </p-message>
              }
            </div>
            <div class="col-12 mb-4">
              <p-button [label]="'Auth.SendResetInstructions' | translate"
                type="submit"
                [disabled]="!forgotPasswordForm.valid"
                [loading]="submitInProgress"
                styleClass="p-button-rounded w-full" />
            </div>
          </div>
        </form>
      </div>
      <div class="col-1"></div>
      <div class="col-12">
        <div class="col-2 p-0 col-offset-5">
          <app-language-selector />
        </div>
      </div>
    </div>
  </div>
</div>
